import { render, staticRenderFns } from "./CharacterEditingTabs.vue?vue&type=template&id=6552bf62&lang=pug&"
import script from "./CharacterEditingTabs.vue?vue&type=script&lang=js&"
export * from "./CharacterEditingTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterEditingTabs.vue"
export default component.exports